import type { NDateLocale } from './enUS'
import { mn } from 'date-fns/locale'

const dateMnMN: NDateLocale = {
  name: 'mn-MN',
  locale: mn
}

export default dateMnMN
